import { Button, Popover, Tooltip } from '@blueprintjs/core';

import styles from './OverflowTabs.module.css';

import { IApplication } from '../../store/state';
import { useApplicationDetail, usePerson } from '@axo/shared/data-access/hooks';
import { getApplicationTabLabel } from './ApplicationTabLabel';
import { getProductIcon } from '../ApplicationCard/ProductIcon';
import React, { Fragment, useState } from 'react';

interface IOverflowTabsProps {
  data: IApplication[];
  onSelect: (value: IApplication) => void;
  onClose: (e: React.MouseEvent, value: IApplication) => void;
  disabled?: boolean | undefined;
}

function OverflowTabItem({
  application,
  onSelect,
  onClose,
}: {
  application: IApplication;
  onSelect(): void;
  onClose(event: React.MouseEvent): void;
}) {
  const detail = useApplicationDetail(application.applicationID);
  const person = usePerson(detail.data?.PersonID);
  const label = getApplicationTabLabel(detail, person);
  return (
    <Fragment>
      <Tooltip
        content={
          <span>
            {detail.data?.Product} application: {application.humanReadableID}
          </span>
        }
      >
        <Button
          minimal
          icon={getProductIcon(detail.data?.Product)}
          className={styles.noHover}
          text={label ?? application.humanReadableID}
          onClick={onSelect}
        />
      </Tooltip>
      <Button minimal icon="delete" onClick={onClose} />
    </Fragment>
  );
}

export function OverflowTabs({
  data,
  onSelect,
  onClose,
  disabled,
}: IOverflowTabsProps) {
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);
  return (
    <Popover
      interactionKind="hover"
      content={
        <div className={styles.popoverContent}>
          {data.map((application) => (
            <OverflowTabItem
              key={application.applicationID}
              application={application}
              onSelect={() => {
                onSelect(application);
                handleClose();
              }}
              onClose={(e) => {
                onClose(e, application);
              }}
            />
          ))}
        </div>
      }
      minimal
      placement="bottom"
      isOpen={isOpen}
      onClose={handleClose}
    >
      <Button
        minimal
        icon="more"
        title="Other open applications"
        disabled={disabled}
        onClick={handleOpen}
      />
    </Popover>
  );
}
